import { deserialize } from 'cerialize'
import { getDate } from 'Helpers'
import {
	RbidosAccessAgentModel,
	RbidosDocumentType,
	StatusRbidosSlug,
} from 'Pages/registry_business_access_neo'

export class RbidosAccessModel {
	@deserialize public id: number
	@deserialize public name: string
	@deserialize public created_at: string
	@deserialize public updated_at: string
	@deserialize public status: StatusRbidosSlug
	@deserialize public message: string | { detail: string }
	@deserialize public agents: RbidosAccessAgentModel[]
	@deserialize public is_deleted: boolean
	@deserialize public territorial_bank: string
	@deserialize public full_name: string
	@deserialize public email: string
	@deserialize public auto_processing: string
	@deserialize public consent: boolean
	@deserialize public infotecs_id: string
	@deserialize public company_id: number
	@deserialize public last_event: {
		status: StatusRbidosSlug
		message: string
		old_status: string
	}

	@deserialize public entity_type: string
	@deserialize public entity_ogrn: string
	@deserialize public entity_inn: string
	@deserialize public entity_kpp: string

	@deserialize public entity_postal_code: string
	@deserialize public entity_region: string
	@deserialize public entity_district: string
	@deserialize public entity_city: number
	@deserialize public entity_street: string
	@deserialize public entity_house_type: string
	@deserialize public entity_house: string
	@deserialize public entity_block: string
	@deserialize public entity_apartment: string

	@deserialize public admin_first_name: string
	@deserialize public admin_last_name: string
	@deserialize public admin_middle_name: string

	@deserialize public admin_birth_date: string
	@deserialize public admin_birthplace: string
	@deserialize public admin_gender: number
	@deserialize public admin_phone: string
	@deserialize public admin_snils: string
	@deserialize public admin_inn: string
	@deserialize public admin_position: number
	@deserialize public admin_acts_on: string

	@deserialize public admin_internal_passport_series: string
	@deserialize public admin_internal_passport_number: string
	@deserialize public admin_internal_passport_issued: string
	@deserialize public admin_internal_passport_issued_by: string
	@deserialize public admin_internal_passport_issue_code: string

	@deserialize public admin_address_postal_code: number
	@deserialize public admin_address_district: string
	@deserialize public admin_address_city: string
	@deserialize public admin_address_city_id: number
	@deserialize public admin_address_region_code: number
	@deserialize public admin_address_street: string
	@deserialize public admin_address_house: string
	@deserialize public admin_address_block: string
	@deserialize public admin_address_house_type: string
	@deserialize public admin_address_apartment: string
	@deserialize public required_fields: string[]
	@deserialize public allowed_statuses: {
		draft: boolean
		at_verification: boolean
		sent: boolean
		return: boolean
		refusal: boolean
		at_registration: boolean
		infotecs_return: boolean
		infotecs_refusal: boolean
		registered: boolean
		correction: boolean
	}
	@deserialize public permissions: {
		destroy: boolean
		restore: boolean
		resend_sms: boolean
		synchronize: boolean
		check_infotecs_status: boolean
		send_signature: boolean
	}
	@deserialize public documents?: RbidosDocumentType[]
	@deserialize public show_button?: boolean

	public get status_localized(): string | undefined {
		return `rbidos_access.status_${this?.status}`
	}
	public get created_at_formatted(): string | undefined {
		return getDate(this?.created_at)
	}
	public get updated_at_formatted(): string | undefined {
		return getDate(this?.updated_at)
	}
}
